import { createSlice } from '@reduxjs/toolkit';
import { createActivity, IActivity } from '../../../models/activities';

interface IActivityState {
    activities: IActivity[],
    activity: IActivity,
    isLoading: boolean,
};

const initialState: IActivityState = {
    activities: [],
    activity: createActivity({}),
    isLoading: false,
};

export const activitiesSlice = createSlice({
    name: 'activities',
    initialState,
    reducers: {
        setActivities: (state, action) => {
            state.isLoading = false;
            state.activities = action.payload.activities;
        },
        setActivity: (state, action) => {
            state.isLoading = false;
            state.activity = action.payload.activity;
        },
        startLoadingActivities: (state) => {
            state.isLoading = true;
        },
        updateActivities: (state, action) => {
            state.isLoading = false;

            const updated: IActivity[] = state.activities.map((item: IActivity) => {
                if (item.id === action.payload.activity.id)
                    return action.payload.activity;
                return item;
            });
            state.activities = updated;
        },
    }
});

// Action creators are generated for each case reducer function
export const {
    setActivities,
    setActivity,
    startLoadingActivities,
    updateActivities
} = activitiesSlice.actions;